module.exports = __webpack_public_path__ + "static/media/logo-animado.a3359901.webm";